function someTagsApply(tags, testTags) {
  return testTags.some(t => tags.includes(t));
}
function allTagsApply(tags, testTags) {
  return testTags.every(t => tags.includes(t));
}
export { allTagsApply, someTagsApply };
